module.exports = __webpack_public_path__ + "static/media/corporate-services-img17.39d008c7.jpg";